import { render, staticRenderFns } from "./next-grade.vue?vue&type=template&id=202d97b7&"
import script from "./next-grade.vue?vue&type=script&lang=js&"
export * from "./next-grade.vue?vue&type=script&lang=js&"
import style0 from "./next-grade.vue?vue&type=style&index=0&lang=css&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports